import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import FoundationSection from '../components/FoundationSection';

const Homepage = () => {
  return (
    <div data-testid="homepage">
      <Navbar />
      <Hero />
      <FoundationSection />
      
      <section className="py-24 bg-secondary">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-primary mb-6">
            Serving Tampa Bay
          </h2>
          <p className="text-lg leading-relaxed text-muted-foreground mb-8">
            Lantern Prep accepts twelve students in our founding cohort each year in St. Petersburg and the greater Tampa Bay area.
          </p>
          <p className="text-lg leading-relaxed text-muted-foreground mb-8">
            If you're ready to begin the process, we invite you to request a consultation.
          </p>
          <a
            href="/contact"
            className="inline-block bg-primary text-primary-foreground px-10 py-4 rounded-sm font-medium hover:bg-primary/90 transition-all"
          >
            Request Consultation
          </a>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Homepage;